import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StoreProvider } from './hooks/useStore';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// React Query client with sensible defaults for dashboard
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s — dashboard data refreshes moderately
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <StoreProvider>
          <RouterProvider router={router} />
        </StoreProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
